import { Table, Badge, Stack, Text, Anchor, ActionIcon, Tooltip } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { formatSmartDate, formatTimestamp } from '@/shared/utils/date';
import type { ContentTableRow } from '../AppContentUtils';

interface AppContentTableProps {
  rows: ContentTableRow[];
  childLabel: string;
  onEdit: (llId: number) => void;
  onDelete: (row: ContentTableRow) => void;
}

export function AppContentTable({ rows, childLabel, onEdit, onDelete }: AppContentTableProps) {
  if (rows.length === 0) {
    return (
      <Text c="dimmed" ta="center" py="xl">
        No items found.
      </Text>
    );
  }

  return (
    <Table verticalSpacing="sm">
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Title</Table.Th>
          <Table.Th w={100}>Status</Table.Th>
          <Table.Th w={100}>{childLabel}</Table.Th>
          <Table.Th w={120}>Created</Table.Th>
          <Table.Th w={50}>Actions</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {rows.map((row) => (
          <Table.Tr key={row.llId}>
            <Table.Td>
              <Stack gap={2}>
                <Anchor
                  component="button"
                  size="sm"
                  fw={500}
                  onClick={() => onEdit(row.llId)}
                  style={{ textAlign: 'left' }}
                >
                  {row.title}
                </Anchor>
                <Text size="xs" c="dimmed" ff="monospace">
                  {row.displayId}
                </Text>
              </Stack>
            </Table.Td>
            <Table.Td>
              <Badge
                variant="light"
                color={row.isActive ? 'green' : 'gray'}
                size="sm"
              >
                {row.isActive ? 'Active' : 'Inactive'}
              </Badge>
            </Table.Td>
            <Table.Td>
              <Text size="sm" c="dimmed">
                {row.childCount}
              </Text>
            </Table.Td>
            <Table.Td>
              <Tooltip label={formatTimestamp(row.created)} withArrow>
                <Text size="sm" c="dimmed">
                  {formatSmartDate(row.created)}
                </Text>
              </Tooltip>
            </Table.Td>
            <Table.Td>
              <ActionIcon
                variant="subtle"
                color="red"
                size="sm"
                onClick={() => onDelete(row)}
              >
                <IconTrash size={14} />
              </ActionIcon>
            </Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}
